// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3Prv5","amount":"Amount_amount__rrW51","tip":"Amount_tip__3klpr","tipHeader":"Amount_tipHeader__u09gB","tipsWrap":"Amount_tipsWrap__3FM3T"};